








































import { Prop, Component, Vue } from 'vue-property-decorator';
import { colors, IMatrix } from '@/misc';

@Component({})
export default class MatrixTable extends Vue {
  @Prop() protected matrix!: IMatrix;

  protected colors = colors;
}
